import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { applyTextEffect } from './TextEffects.js';

gsap.registerPlugin(ScrollTrigger);

const setup = () => {
  const triggers = document.querySelectorAll('.w-b-single-media');

  let mediaManager = gsap.matchMedia();
  mediaManager.add(
    {
      isMobile: `(max-width: 768px), (min-width: 768px) and (max-width: 1366px) and (orientation: portrait)`,
      isDesktop: `(min-width: 768px) and (max-width: 1366px) and (orientation: landscape), (min-width: 1366px)`,
    },
    (context) => {
      let { isDesktop, isMobile } = context.conditions;

      if (isDesktop) {
        triggers.forEach((trigger) => {
          const inner = trigger.firstElementChild;

          gsap.set(inner, { '--_progress': 1 });
          gsap.to(inner, {
            '--_progress': 0,
            duration: 2,
            scrollTrigger: {
              trigger: inner,
              start: 'top top',
              end: 'bottom bottom',
              pin: true,
              pinSpacer: trigger,
              pinSpacing: false,
              scrub: true,
            },
          });

          applyTextEffect(
            'words',
            inner.querySelectorAll(
              '[data-w-b-single-media-title], [data-w-b-single-media-text]'
            ),
            {
              trigger,
              start: 'bottom 120%',
            }
          );
        });
      }
    }
  );
};

export default function SingleMedia() {
  return {
    init: () => {
      setup();
    },
  };
}
